module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00076.1afb4dc.png";